/**
 * `window.localStorage` can be null (Android WebViews with DOM storage
 * disabled), throw on access (cookies blocked), or throw on write (quota,
 * private mode). These helpers never throw; reads fall back to null and
 * writes report success as a boolean.
 */

export const getLocalStorageItem = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setLocalStorageItem = (key: string, value: string): boolean => {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const removeLocalStorageItem = (key: string): boolean => {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};
